export default {
  namespaced: true,
  state: {
    value: null,
    services: []
  },
  mutations: {
    setServices(state, data) {
      state.services = data
    },
    updateValue(state, value) {
      state.value = value
    }
  },
  getters: {
    serviceList(state) {
      return state.services
    }
  },
  actions: {
    updateValueAction({ commit }, value) {
      commit('updateValue', value)
    },
    async getServices({ dispatch, commit }) {
      try {
        const res = await dispatch(
          'app/makeCall',
          {
            route: 'service.get'
          },
          { root: true }
        )
        commit('setServices', res.data.installedServices)
      } catch (e) {
        throw e.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/service.js